import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "لا أعرف أيّ مسار يناسب حالتي. ماذا أفعل؟",
    a: "ابدأ بتعبئة نموذج التحقق المجاني في الأعلى. نعطيك توصية مبدئية خلال دقائق، ثم نحدد معك إن كنت تحتاج استشارة فقط أو دعماً كاملاً.",
  },
  {
    q: "هل تكفيني الاستشارة إذا أردت تنفيذ الإجراءات بنفسي؟",
    a: "في أغلب الحالات البسيطة، نعم. ستحصل على تقييم واضح لحالتك، قائمة مستندات، وخطوات عملية تقوم بها بنفسك.",
  },
  {
    q: "ما الذي يشمله الدعم الكامل؟",
    a: "تحليل لوضعك، تخطيط لمسار الإقامة المناسب، تجهيز ومراجعة المستندات، ومرافقتك خلال المراحل الأساسية للإجراءات.",
  },
  {
    q: "هل يمكنني التواصل معكم بالعربية؟",
    a: "نعم. الدعم الكامل يتم باللغة العربية، في الاستشارة والمتابعة والمستندات.",
  },
  {
    q: "هل يجب أن تكون كل مستنداتي جاهزة قبل التواصل؟",
    a: "لا. يمكنك التواصل حتى لو لم تكن متأكداً ما الذي تحتاجه. جزء من عملنا هو أن نحدد لك ما ينقصك بالضبط.",
  },
  {
    q: "هل تساعدون فقط الطلاب؟",
    a: "لا. نساعد من يقيم حالياً في بولندا أو يخطط للعيش فيها، سواء كانت حالته دراسة، عمل، أو حالة أخرى.",
  },
  {
    q: "بعد كم من الوقت يمكنني البدء؟",
    a: "عادةً خلال 24–48 ساعة من تعبئة النموذج أو الدفع. نرسل لك خطوات التنسيق ونبدأ بجمع المعلومات الأساسية.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-20 lg:py-24 bg-white"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-start mb-10">
          <div className="text-emerald-700 text-sm font-semibold mb-3">
            الأسئلة الشائعة
          </div>
          <h2 className="font-tajawal text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
            أسئلة يطرحها أغلب الأشخاص قبل البدء
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              className="bg-slate-50 border border-slate-200 rounded-2xl px-5 data-[state=open]:bg-white data-[state=open]:border-emerald-200 transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-start font-tajawal text-base sm:text-lg font-bold text-slate-900 hover:no-underline py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-slate-600 text-sm md:text-base leading-relaxed pb-5"
                data-testid={`faq-content-${i}`}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
